import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Tabs } from '@treams/treams-ui';

export default function UserConversationTabs(props: { user?: graphql.User }) {
	const { t } = useTranslation();
	const hidden = useFeature(graphql.FeatureName.HideYouAsConversationPartner);

	if (!props.user || hidden) return null;

	return (
		<Tabs.Container>
			<Tabs.Item
				title={t('user.conversations.tab.incoming.title', {
					name: props.user.firstName,
				})}
				selected
				path={`/users/${props.user.id}/conversations`}
			/>
			<Tabs.Item
				title={t('user.conversations.tab.outgoing.title', {
					name: props.user.firstName,
				})}
				path={`/users/${props.user.id}/conversations/outgoing`}
			/>
		</Tabs.Container>
	);
}
